import { FC } from 'react';
import Image from 'next/image';
import starsLogo from '@puzzlio/ui/logos/stars.svg';
import { cn } from '@/app/lib/utils';

/*
  The game's logo, from the same file the app draws. The extra classes make the <img> lay out as the
  inline <svg> this used to be: no preflight max-width cap, free to shrink in a flex row, and the
  drawing letterboxed rather than stretched when it does.
*/
export const StarsLogo: FC<{ className?: string }> = ({ className }) => {
  return <Image src={starsLogo} alt="" className={cn('size-[124px] max-w-none min-w-0 object-contain', className)} />;
};
